import React from "react";
import { Heading, Stack } from "@chakra-ui/core";

function BrowserHeaderMockup({ title }) {
  return (
    <>
      <Stack
        color="#fafafa"
        my="20px"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        spacing={0}
      >
        {/* <Box as={FaShoppingBasket} size="24px" /> */}
        <Heading textTransform="uppercase" as="h4" size="md">
          {title}
        </Heading>
      </Stack>
    </>
  );
}

export default BrowserHeaderMockup;
